import { render, staticRenderFns } from "./ArrowDownIcon.vue?vue&type=template&id=46f734d6&scoped=true&"
import script from "./ArrowDownIcon.vue?vue&type=script&lang=js&"
export * from "./ArrowDownIcon.vue?vue&type=script&lang=js&"
import style0 from "./ArrowDownIcon.vue?vue&type=style&index=0&id=46f734d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f734d6",
  null
  
)

export default component.exports